import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderService, PortalService } from 'src/app/services';
import { IDelegatedUsers, IPortalConfig, NotificationType } from 'src/app/models';
import { TopNotificationService } from '../top-notification/top-notification.service';
import { TrainingService } from 'src/app/services/training.service';

@Component({
    selector: 'medpt-delegated-user-info',
    templateUrl: './delegated-user-info.component.html',
    styleUrls: ['./delegated-user-info.component.scss'],
    standalone: false
})
export class DelegatedUserInfoComponent implements OnInit {
  @Input() delegateInputModel!: any;
  portalInfo!: IPortalConfig;
  DelegatedUsers: IDelegatedUsers[] = [];

  constructor(
    public modal: NgbActiveModal,
    private notificationService: TopNotificationService,
    private loaderService: LoaderService,
    private portalService: PortalService,
    private trainingService: TrainingService,

  ) {
    this.portalInfo = this.portalService.portalConfiguation.getValue();
    
  }

  ngOnInit(): void {
    this.getDetails();
  }

  private getDetails() {
    this.loaderService.showLoader();

    this.trainingService.getDelegatedUserDetails(<string>this.portalInfo.SponsorName, <number>this.portalInfo.PortalID, this.delegateInputModel.AssetID, this.delegateInputModel.UserID)
      .then(
        (result: IDelegatedUsers[]) => {
          this.DelegatedUsers = result;
        }, (error: any) => {
          this.notificationService.showNotification("An error occured during fetch information.", NotificationType.Error);
        }).catch(() => {
          this.notificationService.showNotification("An error occured during fetch information.", NotificationType.Error);
        }).finally(() => {
          this.loaderService.hideLoader();
        });
  }
}
